import { useEffect, useMemo, useState } from "react";
import { CategoryType } from "../components/CategorySelect";
import { recommended, RecommendedResult } from "../lib/robozinho/recommended";

export function useRecommended(
    defaultCategory: CategoryType = "hetero"
): [RecommendedResult | null, boolean, (category: CategoryType) => void, () => void] {
    const [result, setResult] = useState<RecommendedResult | null>(null);
    const [category, setCategory] = useState(defaultCategory);
    const [isLoading, setLoading] = useState(false);

    const load = useMemo(() => {
        return () => {
            setLoading(true);
            recommended(category).then((searchResult) => {
                setResult({
                    pagination: searchResult.pagination,
                    videos: [
                        ...(result ? result.videos : []),
                        ...searchResult.videos,
                    ],
                });
                setLoading(false);
            });
        };
    }, [category, result]);

    useEffect(load, []);

    useEffect(() => {
        setResult(null);
        load();
    }, [category]);

    return [result, isLoading, setCategory, load];
}
